<div class="breadcrumb-area">
    <h1>Invoice</h1>

    <ol class="breadcrumb">
        <li class="item"><a routerLink="/admin-dashboard"><i class='bx bx-home-alt'></i></a></li>

        <li class="item">Dashboard</li>

        <li class="item">Invoice</li>
    </ol>
</div>

<div class="card recent-orders-box mb-30">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h3>Invoices Listings</h3>

        <div class="dropdown">
            <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class='bx bx-dots-horizontal-rounded' ></i>
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-show'></i> View
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-edit-alt'></i> Edit
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-trash'></i> Delete
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-printer'></i> Print
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-download'></i> Download
                </a>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Invoice</th>
                        <th>Customer</th>
                        <th>Purchase On</th>
                        <th>Amount</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of items">
                        <td>#{{item._id}}</td>
                        <td class="name"><img src="assets/img/default/admin.jpg" alt="image"> {{item.customerName}}</td>
                        <td>{{item.created}}</td>
                        <td>{{item.price | currency}}</td>
                        <td><span class="badge badge-primary">{{item.status}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>